import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

// 引入 ui框架
import '@/assets/config/ui-config.js'
// 引入样式
import '@/assets/less/common.less'
//导入vuex数据
import store from '@/store'
// 插入过滤器
import '@/assets/config/filter-config.js'
// 引入 全局组件
import "@/assets/config/global-component.js"
import check from "@/assets/js/model/elTip/elTip.js"
// 引入 echars
import echart from "@/assets/config/echarts-config.js"
Vue.prototype.$echart = echart;
// 引入 axios
import axios from "axios";
import {instance} from '@/assets/config/axios-config.js';

Vue.prototype.$axios = axios;
Vue.prototype.$http = instance;

// 引入常用函数
import $func,{ successTip,errorTip } from '@/assets/js/common.js'
Vue.prototype.$func = $func;
Vue.prototype.successTip = successTip;
Vue.prototype.errorTip = errorTip;

// 引入地址配置
import $url from '@/assets/config/address-config.js'
Vue.prototype.$url = $url;


import router from '@/router/index.js'


new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
